import { DrawerCustom } from '../../components/drawer/Drawer'
import { SkeletonRequestCard } from './skeleton/SkeletonRequestCard';
import { useSelector } from 'react-redux';
import { formatDateTime } from '../../common/formatDateText';
import { PropertyListItem } from '../../components/PropertyListItem';
import { PropertyItem } from '../../components/PropertyItem';


export const DrawerDetailsPayment = ({
    isOpenDrawerFilters,
    toggleDrawerFilters,
}) => {
    const {
        requestInvoiceSelected,
        loadingRequestInvoiceSelected
    } = useSelector((state) => state.request);

    const { requestBy, numberRequest, payment, approvedBy, updatedAt } = requestInvoiceSelected || {};

    return (
        <DrawerCustom
            isOpen={isOpenDrawerFilters}
            toggleDrawer={toggleDrawerFilters}
            direction='right'
            title='Detalle del pago'
            subtitle='Se muestra el detalle del pago y los datos del estudiante'
            footer={(
                <div className='flex items-center justify-start gap-4 overflow-hidden'>
                    <button
                        type='button'
                        onClick={() => toggleDrawerFilters()}
                        className='rounded-md font-semibold text-md text-white bg-indigo-600 hover:bg-indigo-700 px-4 py-2'
                    >Cerrar</button>
                </div>
            )}
        >
            {
                loadingRequestInvoiceSelected && (
                    <SkeletonRequestCard />
                )
            }
            {
                !loadingRequestInvoiceSelected && (
                    <>
                        <p className='font-semibold'>Datos del estudiante</p>
                        <div className='mt-2 p-4'>

                            <div className='w-full border rounded-md border-gray-200'>
                                <PropertyListItem>
                                    <PropertyItem
                                        title={`Solicitud`}
                                        description={`#${numberRequest}`}
                                        positionTile='md:text-left'
                                    />
                                    <PropertyItem
                                        title={`Solicitado por`}
                                        description={`[${requestBy?.matricula}] - ${requestBy?.firstName} ${requestBy?.secondName ? requestBy?.secondName : ''} ${requestBy?.lastName} ${requestBy?.secondSurname ? requestBy?.secondSurname : ''}`}
                                        positionTile='md:text-left'
                                        capitalize={true}
                                    />
                                    <PropertyItem
                                        title={`Regimen fiscal `}
                                        description={`${requestBy?.taxRegime ? requestBy?.taxRegime : '-'}`}
                                        positionTile='md:text-left'
                                        uppercase={true}
                                    />
                                    <PropertyItem
                                        title={`RFC`}
                                        description={`${requestBy?.rfc ? requestBy?.rfc : '-'}`}
                                        positionTile='md:text-left'
                                        uppercase={true}
                                    />
                                    <PropertyItem
                                        title={`Codigo postal`}
                                        description={`${requestBy?.zipCode ? requestBy?.zipCode : '-'}`}
                                        positionTile='md:text-left'

                                    />
                                    <PropertyItem
                                        title={`Correo electronico`}
                                        description={`${requestBy?.emailTax ? requestBy?.emailTax : '-'}`}
                                        positionTile='md:text-left'
                                    />
                                    <PropertyItem
                                        title={`Telefono`}
                                        description={`${requestBy?.phone ? requestBy?.phone : '-'}`}
                                        positionTile='md:text-left'
                                    />
                                </PropertyListItem>
                            </div>
                        </div>
                        <p className='font-semibold mt-2'>Detalles del pago</p>
                        <div className='mt-2 p-4'>
                            <div className='w-full border rounded-md border-gray-200'>
                                <PropertyListItem>
                                    <PropertyItem
                                        title={`Numero de cuenta`}
                                        description={`${payment?.account?.nameAccount ? payment?.account?.nameAccount : '-'}`}
                                        positionTile='md:text-left'
                                        uppercase={true}
                                    />
                                    <PropertyItem
                                        title={`Numero de cuenta`}
                                        description={`${payment?.account?.numberAccount ? payment?.account?.numberAccount : '-'}`}
                                        positionTile='md:text-left'
                                    />
                                    <PropertyItem
                                        title={`Monto`}
                                        description={`$ ${payment?.amount ? payment?.amount : '-'}`}
                                        positionTile='md:text-left'
                                    />
                                    <PropertyItem
                                        title={`Ultima actualización`}
                                        description={updatedAt ? (formatDateTime(updatedAt)) : '-'}
                                        positionTile='md:text-left'
                                        capitalize={true}
                                    />
                                    <PropertyItem
                                        title={`Tipo de pago`}
                                        description={`${payment?.paymentType ? payment?.paymentType : '-'}`}
                                        positionTile='md:text-left'
                                        uppercase={true}
                                    />
                                    <PropertyItem
                                        title={`Estutos del pago`}
                                        description={`${payment?.status ? payment?.status : '-'}`}
                                        positionTile='md:text-left'
                                        uppercase={true}
                                    />
                                    <PropertyItem
                                        title={`Validado por`}
                                        description={`${approvedBy?.firstName} ${approvedBy?.secondName ? approvedBy?.secondName : ''} ${approvedBy?.lastName} ${approvedBy?.secondSurname ? approvedBy?.secondSurname : ''}`}
                                        positionTile='md:text-left'
                                        capitalize={true}
                                    />
                                </PropertyListItem>
                            </div>
                        </div>
                    </>
                )
            }

        </DrawerCustom>
    )
}
